// @flow
import type { State } from "@store/reducers";
import type {
  CurrentMonitoringStage,
  MonitoringHistory,
} from "@modules/profile/reducer/my-absence-stage/types";
import type { NotificationContact } from "@modules/profile/types";
import { getPagination } from "@selectors";
import type { PaginationExtendedType } from "@types";
import type { MyDetails } from "@modules/profile/reducer/my-details/types";

export type GetMyAbsenceMonitoringHistory = (state: State) => Array<MonitoringHistory>;
export type GetMyEmployees = (state: State) => Array<NotificationContact>;
export type GetMyEmployeesPage = (state: State) => number;

export type GetSelectedEmployeeId = (state: State) => ?number;
export type GetMyCurrentAbsenceMonitoringStage = (state: State) => CurrentMonitoringStage;

// Common
export const getError = (state: Object): ?string => (state.profile || {}).error;

export const getSuccessMessage = (state: Object): ?boolean => (state.profile || {}).success;

export const isLoading = (state: State): boolean => {
  const detailsLoading = (state.profile.myDetails || {}).requestsInProgress > 0;
  const absencesLoading = (state.profile.myAbsences || {}).requestsInProgress > 0;
  const employeesLoading = (state.profile.myEmployees || {}).requestsInProgress > 0;

  return detailsLoading || absencesLoading || employeesLoading;
};

// My Details

export const getContactInfoModalVisible = (state: State): boolean =>
  state.profile.myDetails.modals.contactInfo.visible;

export const getChangePasswordModalVisible = (state: State): boolean =>
  state.profile.myDetails.modals.changePassword.visible;

// My Absences
export const getMyAbsences = (state: State): Object[] =>
  ((state.profile.myAbsences || {}).absences || {}).content || [];

export const getMyAbsencesPagination = (state: State): Object | null =>
  ((state.profile.myAbsences || {}).absences || {}).pagination || null;

// My Absence Stage
export const getMyAbsenceMonitoringHistory = (state: State): MonitoringHistory[] =>
  state.profile.myAbsenceStage.monitoringHistory || [];

export const getMyCurrentAbsenceMonitoringStage = (state: State): CurrentMonitoringStage | null =>
  state.profile.myAbsenceStage.current;

// Placeholder
export const someValue = () => null;

// My Employees
export const getMyEmployees = (state: State): Array<NotificationContact> =>
  state.profile.myEmployees.list.content;

export const getMyEmployeesPagination = (state: State): PaginationExtendedType =>
  getPagination(state.profile.myEmployees.list);

export const getMyEmployeesPage = (state: State): ?number =>
  (getMyEmployeesPagination(state) || {}).pageNumber;

export const getSelectedEmployeeId = (state: State): ?number =>
  state.profile.myEmployees.selectedEmployeeId;

export const selectMyEmployees = (state: State): Array<NotificationContact> =>
  state.profile.myEmployees.list.content || [];

export const getAddAbsenceModal = (state: State): Object =>
  state.profile.myAbsences.modals.addAbsence;

export const getAddAbsenceSchema = (state: State): ?Object =>
  state.profile.myAbsences.absencesSchema;

export const getAbsenceDetails = (state: State): ?Object => state.profile.myAbsences.absenceDetails;
